import React, { useCallback, useEffect, useState } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import slider4 from "../asset/slider-4.webp";
import slider5 from "../asset/slider-5.jpg";
import slider6 from "../asset/slider-6.jpg";

const slides = [
  { image: slider4, alt: "Cybersecurity protection represented on wooden blocks", eyebrow: "Secure digital foundations", title: "Technology built for confident growth", copy: "We help ambitious businesses create reliable websites, applications, and digital strategies that turn complex challenges into clear opportunities." },
  { image: slider5, alt: "Digital technology and business services", eyebrow: "Web & application development", title: "Digital experiences that move business forward", copy: "From high-performing websites to tailored business applications, our team delivers practical technology designed around your goals." },
  { image: slider6, alt: "Connected digital business solutions", eyebrow: "Strategy with measurable impact", title: "A technology partner for every next step", copy: "Combine thoughtful design, robust engineering, and focused marketing to reach customers and operate more efficiently." },
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const next = useCallback(() => setCurrent((slide) => (slide + 1) % slides.length), []);
  const previous = () => setCurrent((slide) => (slide - 1 + slides.length) % slides.length);
  const interact = (action) => { setAutoplay(false); action(); };

  useEffect(() => {
    if (!autoplay) return undefined;
    const timer = window.setInterval(next, 6000);
    return () => window.clearInterval(timer);
  }, [autoplay, next]);

  const slide = slides[current];
  return (
    <section className="relative isolate min-h-[500px] overflow-hidden bg-slate-900 sm:min-h-[560px] lg:min-h-[620px]" aria-roledescription="carousel" aria-label="Lumetra Softech services" onPointerDown={() => setAutoplay(false)}>
      {slides.map((item, index) => (
        <img key={item.image} src={item.image} alt={index === current ? item.alt : ""} aria-hidden={index !== current} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${index === current ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-900/65 to-slate-900/20" aria-hidden="true" />
      <div className="relative mx-auto flex min-h-[500px] max-w-7xl items-center px-5 py-16 sm:min-h-[560px] lg:min-h-[620px] lg:px-8">
        <div className="max-w-2xl border-l-4 border-teal-400 bg-slate-950/35 p-6 text-white backdrop-blur-[2px] sm:p-9">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-teal-200">{slide.eyebrow}</p>
          <h1 className="text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">{slide.title}</h1>
          <p className="mt-5 max-w-xl text-base leading-7 text-slate-100 sm:text-lg">{slide.copy}</p>
          <NavActions />
        </div>
      </div>
      <button type="button" onClick={() => interact(previous)} className="carousel-arrow left-4" aria-label="Show previous slide"><FiArrowLeft aria-hidden="true" /></button>
      <button type="button" onClick={() => interact(next)} className="carousel-arrow right-4" aria-label="Show next slide"><FiArrowRight aria-hidden="true" /></button>
      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 gap-2" role="group" aria-label="Choose slide">
        {slides.map((item, index) => (
          <button key={item.image} type="button" onClick={() => interact(() => setCurrent(index))} className={`h-2.5 rounded-full transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${index === current ? "w-8 bg-teal-300" : "w-2.5 bg-white/60 hover:bg-white"}`} aria-label={`Show slide ${index + 1}`} aria-current={index === current ? "true" : undefined} />
        ))}
      </div>
      <p className="sr-only" aria-live="polite">Slide {current + 1} of {slides.length}: {slide.title}</p>
    </section>
  );
};

const NavActions = () => (
  <div className="mt-7 flex flex-wrap gap-3">
    <NavLink to="/contact" className="inline-flex min-h-11 items-center rounded-md bg-teal-600 px-5 py-2.5 text-sm font-bold text-white shadow hover:bg-teal-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-white">Start a conversation</NavLink>
    <NavLink to="/web-development" className="inline-flex min-h-11 items-center rounded-md border border-white/50 bg-white/10 px-5 py-2.5 text-sm font-bold text-white hover:bg-white hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-white">Explore our services</NavLink>
  </div>
);

export default Hero;
